import isoDark from '@/assets/images/iso-dark-mode.png'
import isoLight from '@/assets/images/iso-light-mode.png'
import { UserTaskToasts } from '@/components/UserTaskToasts'
import {
  SecurityContextProvider,
  useSecurityContext,
} from '@/contexts/SecurityContext'
import { useSkipToMain } from '@/hooks/useAccessibility'
import { useAuth } from '@/hooks/useAuth'
import {
  NavigationContextProvider,
  useThemeContext,
} from '@gravitate-js/excalibrr'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { BottomNavSlot } from './Slots/BottomNav'
import { PageToolbarSlot } from './Slots/PageToolbar'
import { pageConfig } from './pageConfig'

const AuthenticatedContent = () => {
  const { logout } = useAuth()
  const { getScopes, hasGravitateAccess } = useSecurityContext()
  const { isDarkTheme } = useThemeContext()
  const location = useLocation()

  useSkipToMain()

  const isGravitateUser = hasGravitateAccess()
  const currentPath = location.pathname

  if (!isGravitateUser) {
    const isOnRestrictedRoute =
      currentPath.includes('crossroads') && !currentPath.includes('dashboard')
    if (isOnRestrictedRoute || currentPath === '/' || currentPath === '') {
      return <Navigate to='/integration-management/overview' replace />
    }
  }

  return (
    <NavigationContextProvider
      getScopes={getScopes}
      handleLogout={logout}
      pageConfig={pageConfig}
      // TODO: Make userControlPane and updatePreferenceSetting optional in excalibrr
      userControlPane={null}
      updatePreferenceSetting={() => {
        /* */
      }}
      navStyle='compact'
      navLayoutParams={{
        navLogo: (
          <img
            src={isDarkTheme ? isoDark : isoLight}
            alt='Crossroads'
            style={{ width: 24, height: 24 }}
          />
        ),
        quickSearchStyle: 'modal',
        navTitle: 'Crossroads',
        navBottomSlot: <BottomNavSlot />,
        pageToolbarSlot: <PageToolbarSlot />,
      }}
    >
      <Outlet />
      <UserTaskToasts />
    </NavigationContextProvider>
  )
}

export const AuthenticatedApp = () => {
  return (
    <SecurityContextProvider>
      <AuthenticatedContent />
    </SecurityContextProvider>
  )
}
